import React from 'react';
import { Link } from 'react-router-dom';
import { LuArrowLeft } from 'react-icons/lu';

/**
 * Title row at the top of every dashboard page.
 * `back` shows "← label" above the title, for pages reached by clicking into something
 * (a student from the list). Pages opened from the sidebar have no back link.
 *
 * @param {Object} props
 * @param {string} props.title - Page title
 * @param {string} props.subtitle - One line explaining what the page is for
 * @param {React.ReactNode} props.actions - Buttons at the right of the title
 * @param {{to: string, label: string}} props.back - Link to the parent page
 */
const PageHeader = ({ title, subtitle, actions, back }) => {
  return (
    <div className="mb-5">
      {back && (
        <Link
          to={back.to}
          className="mb-1.5 inline-flex items-center gap-1.5 rounded text-[13px] font-medium text-ui-ink-2 transition-colors hover:text-ui-ink"
        >
          <LuArrowLeft aria-hidden className="size-4" />
          {back.label}
        </Link>
      )}
      <div className="flex flex-wrap items-end justify-between gap-x-6 gap-y-3">
        <div className="min-w-0 flex-1">
          <h1 className="text-2xl font-semibold tracking-tight text-ui-ink">{title}</h1>
          {subtitle && <p className="mt-1 text-sm text-ui-ink-2">{subtitle}</p>}
        </div>
        {actions && <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>}
      </div>
    </div>
  );
};

export default PageHeader;
